import getConfig from "src/config/appConfig";
import agendaApiConfig from "./agendaApiConfig";

const ReservationService = {
  async getDaysAvailable(query) {
    const { SERVICIO } = getConfig();
    if (!query.ser_codigo) {
      query.ser_codigo = SERVICIO;
    }
    return await agendaApiConfig.get("/reserva/dias-disponibles", {
      params: query,
    });
  },
  async getDaysAvailableImagenologia(query) {
    const { IMAGENOLOGIA } = getConfig();
    if (IMAGENOLOGIA == "") {
      //query2 = null;
    } else {
      query.ser_codigo = IMAGENOLOGIA;
    }
    return await agendaApiConfig.get("/reserva/dias-disponibles-img", {
      params: query,
    });
  },
  async getDaysAvailableProcedimiento(query) {
    // if(process.env.REACT_APP_SERVICIO_IMG == ""){
    //     //query2 = null;
    // }else{
    //     query.ser_codigo = process.env.REACT_APP_SERVICIO_IMG;
    // }
    query.ser_codigo = "PCD";
    return await agendaApiConfig.get("/reserva/dias-disponibles-pcd", {
      params: query,
    });
  },
  async getDayAvailableDefault(query) {
    console.log(query, "dias");

    const { SERVICIO } = getConfig();
    if (!query.ser_codigo) {
      query.ser_codigo = SERVICIO;
    }
    return await agendaApiConfig.get("/reserva/dia-disponible-predeterminado", {
      params: query,
    });
  },
  async getDayAvailableImagenologiaDefault(query) {
    const { IMAGENOLOGIA } = getConfig();
    if (IMAGENOLOGIA == "") {
      //query2 = null;
    } else {
      query.ser_codigo = IMAGENOLOGIA;
    }
    return await agendaApiConfig.get("/reserva/dia-disponible-predeterminado", {
      params: query,
    });
  },
  async getDayAvailableProcedimientoDefault(query) {
    // let clinica = ManageStorage.getValueFromStorage("clinica");
    // if(clinica != ''){
    //     if(clinica == "CHILLÁN"){
    //         if(process.env.REACT_APP_SERVICIO_CHILLAN != ""){
    //             query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CHILLAN;
    //         }
    //     }else if(clinica == 'PUERTO MONTT'){
    //         if(process.env.REACT_APP_SERVICIO_PTOMONTT != ""){
    //             query.SER_CODIGO = process.env.REACT_APP_SERVICIO_PTOMONTT;
    //         }
    //     }else if(clinica == 'CALAMA'){
    //         if(process.env.REACT_APP_SERVICIO_CALAMA != ""){
    //             query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CALAMA;
    //         }
    //     }else if(clinica == 'LOS ÁNGELES'){
    //         if(process.env.REACT_APP_SERVICIO_LOSANGELES != ""){
    //             query.SER_CODIGO = process.env.REACT_APP_SERVICIO_LOSANGELES;
    //         }
    //     }else if(clinica == 'CONCEPCIÓN'){
    //         if(process.env.REACT_APP_SERVICIO_CONCE != ""){
    query.SER_CODIGO = "PCD"; //process.env.REACT_APP_SERVICIO_CONCE;
    //         }
    //     }

    // }
    return await agendaApiConfig.get(
      "/reserva/dia-disponible-predeterminado-pcd",
      {
        params: query,
      },
    );
  },
  async getHoursAvailable(query) {
    const { SERVICIO } = getConfig();
    if (SERVICIO == "") {
      //query2 = null;
    } else {
      query.ser_codigo = SERVICIO;
    }
    return await agendaApiConfig.get("/reserva/horas-disponibles", {
      params: query,
    });
  },
  async saveReservation(body) {
    return await agendaApiConfig.post("/reserva", body);
  },
  async saveReservationImagenologia(body) {
    return await agendaApiConfig.post("/reserva/imagenologia", body);
  },
  async searchHoursAvailable(codSpeciality = 0, query) {
    // if(process.env.REACT_APP_SERVICIO == ""){
    //     //query2 = null;
    // }else{
    //     query.SER_CODIGO = process.env.REACT_APP_SERVICIO;
    // }
    if (query.SER_CODIGO == null) {
      query.SER_CODIGO = getConfig().SERVICIO;
    }
    return await agendaApiConfig.get(
      `/especialidad/${codSpeciality}/busquedaHoras`,
      {
        params: {
          format: "array",
          ...query,
        },
      },
    );
  },
  async searchHoursAvailableImagenologia(codSpeciality = 0, codExam, query) {
    const { IMAGENOLOGIA } = getConfig();
    if (IMAGENOLOGIA == "") {
      //query2 = null;
    } else {
      query.ser_codigo = IMAGENOLOGIA;
    }
    return await agendaApiConfig.get(
      `/especialidad/${codSpeciality}/busquedaHorasImagenologia/${codExam}`,
      {
        params: {
          format: "array",
          ...query,
        },
      },
    );
  },
  async searchHoursAvailableProcedimiento(codServicio = 0, codProc, query) {
    query.ser_codigo = getConfig().PROCEDIMIENTO;
    return await agendaApiConfig.get(
      `/servicio/${codServicio}/busquedaHorasProcedimiento/${codProc}`,
      {
        params: {
          format: "array",
          ...query,
        },
      },
    );
  },
  async getReservationCanceled(uuid) {
    return await agendaApiConfig.get(`/reserva/anulada/${uuid}`);
  },
  async cancelReservation(body) {
    return await agendaApiConfig.put("/reserva/anular", body);
  },
};

export default ReservationService;
